export default __webpack_public_path__ + "static/media/grey-cross.9c3d3e32.svg";